import type { DateTime } from "luxon";

/** Backend Date and DateTime formats. **Warning:** German format will be removed in the future!! */
export type BackendDateFormat =
  "ISO 8601" | "ISO 8601 RFC822" | "German" | "GermanWithTime";

/**
 * Converts a Luxon DateTime to a backend date or datetime format, using the "German format" by default.
 * Returns null if the provided DateTime is invalid.
 * @param luxonDateTime The Luxon DateTime to convert.
 * @param format The backend date format to use. GermanWithTime and German are deprecated.
 * @returns The backend date or datetime string.
 */
export function luxonDateTimeToBackendDateOrDateTime(
  luxonDateTime: DateTime,
  format: BackendDateFormat = "German"
) {
  const backendIsoDate = luxonDateTime.toISODate();

  if (backendIsoDate === null) {
    throw Error("Invalid date format: " + luxonDateTime.toString());
  }

  if (format === "ISO 8601") {
    return backendIsoDate;
  }

  if (format === "ISO 8601 RFC822") {
    return luxonDateTime.toFormat("yyyy-MM-dd'T'HH:mm:ssZZZ");
  }

  if (format === "GermanWithTime") {
    // console.warn("German date format is deprecated. Please use ISO 8601."); // todo: https://node-energy.atlassian.net/browse/ENG-336
    return luxonDateTime.toFormat("dd.MM.yyyy HH:mm:ss");
  }

  // console.warn("German date format is deprecated. Please use ISO 8601."); // todo: https://node-energy.atlassian.net/browse/ENG-336
  return luxonDateTime.toFormat("dd.MM.yyyy");
}
